import React from "react";
import "./Header.css";

const Header = ({ header }) => {
  return <section className="header"> {header} </section>;
};

export default Header;
